import * as Yup from "yup";

export const MediaAssignTaskSchema = Yup.object({
  taskName: Yup.string().trim().required("Task name is required"),
  brandAsset: Yup.string().trim().required("Task name is required"),
  taskDescription: Yup.string().trim().required("Task description is required"),

  agencyId: Yup.string(),

  deadline: Yup.string().required("Deadline is required"),
});
